import { FocusElement } from './focusElement';

export {
    FocusElement
}


// WEBPACK FOOTER //
// ./src/directives/index.ts